module.exports = __webpack_public_path__ + "static/logo-cf1e06de284220713106d7a6ad7e4898.png";